export const DSP_LINK = 'https://dsp-wireless.com/';
export const WH_LINK = 'https://wirelesswarehousedirect.com/';
//export const DSP_LINK = 'http://localhost:3000/';